import { ref, push, set, update, remove, onValue } from 'firebase/database'
import { db, tref } from './firebase.js'
import { logActivity } from './activity.js'

// Demo Clubs (loaners). /club/demoClubs. Named to avoid the tournament
// demos.js. A demo is "out" until returned; overdue = dueDate passed & !returned.
//   {id}: { memberId, club, manufacturer, serialNumber, barcode, outDate,
//           dueDate, returned, returnedDate, condition, purchaseResult, notes, createdAt }
const BASE = 'club/demoClubs'
export const PURCHASE_RESULTS = ['Pending', 'Purchased', 'Ordered', 'Not purchased']
const today = () => new Date().toISOString().slice(0, 10)

export function watchDemoClubs(cb) { return onValue(tref(BASE), (s) => cb(s.val() || {})) }

export async function createDemo(d) {
  const club = String(d.club || '').trim()
  if (!club) throw new Error('Club is required.')
  const node = push(tref(BASE))
  await set(node, {
    id: node.key, memberId: d.memberId || null, club,
    manufacturer: String(d.manufacturer || '').trim(),
    serialNumber: String(d.serialNumber || '').trim(),
    barcode: String(d.barcode || '').trim(),
    outDate: d.outDate || today(), dueDate: d.dueDate || '',
    returned: false, returnedDate: '', condition: '', purchaseResult: 'Pending',
    notes: String(d.notes || '').trim(), createdAt: Date.now(),
  })
  logActivity({ type: 'demo', memberId: d.memberId || null, icon: '🏌️', text: `Demo out: ${club}${d.manufacturer ? ` (${d.manufacturer})` : ''}` })
  return node.key
}

export async function returnDemo(id, { condition, purchaseResult }, memberId, club) {
  await update(tref(`${BASE}/${id}`), { returned: true, returnedDate: today(), condition: String(condition || '').trim(), purchaseResult: purchaseResult || 'Pending' })
  logActivity({ type: 'demo', memberId: memberId || null, icon: '🏌️', text: `Demo returned: ${club || 'club'}${purchaseResult && purchaseResult !== 'Pending' ? ` — ${purchaseResult}` : ''}` })
}

export async function updateDemo(id, patch) {
  const clean = {}
  for (const k of ['club', 'manufacturer', 'serialNumber', 'barcode', 'outDate', 'dueDate', 'condition', 'notes']) if (patch[k] != null) clean[k] = String(patch[k]).trim()
  if (patch.memberId !== undefined) clean.memberId = patch.memberId || null
  if (patch.purchaseResult != null) clean.purchaseResult = patch.purchaseResult
  await update(tref(`${BASE}/${id}`), clean)
}

export async function deleteDemo(id) { await remove(tref(`${BASE}/${id}`)) }

export const isOverdue = (d) => !d.returned && d.dueDate && d.dueDate < today()
